import {bootstrapApplication} from '@angular/platform-browser';
import {config} from './app/config/app.config';
import {AppComponent} from './app/components/app.component';
import {enableProdMode} from '@angular/core';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}
bootstrapApplication(AppComponent, config)
  .catch((err) => console.error(err));
